import { createContext } from 'react';

import type { CampaignContextType } from '../../campaignTypeSelection/types';

export const CampaignContext = createContext<CampaignContextType>({});
